import { render, staticRenderFns } from "./dialog_discount_card.vue?vue&type=template&id=1bbefbbb&scoped=true&"
import script from "./dialog_discount_card.vue?vue&type=script&lang=js&"
export * from "./dialog_discount_card.vue?vue&type=script&lang=js&"
import style0 from "./dialog_discount_card.vue?vue&type=style&index=0&id=1bbefbbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbefbbb",
  null
  
)

export default component.exports